import React from 'react';
import style from './style.module.scss';

const PingCommoditiesLogo: React.FC<{
  height?: number | string;
  className?: string;
  onlyIcon?: boolean;
}> = ({ height = 32, className, onlyIcon = false }) => (
  <img
    src={onlyIcon ? '/img/logo-ping-icon.svg' : '/img/logo-ping.svg'}
    alt='ping Logo'
    className={`${style['logo-img']} ${className || ''}`.trim()}
    style={height ? { height } : undefined}
    data-testid='ping-logo'
  />
);

export default PingCommoditiesLogo;
